import { Route, Routes as RoutesDom } from "react-router-dom";

// Páginas públicas
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import RegisterOptions from "../pages/RegisterOptions/RegisterOptions";
import RegisterEntrepeneur from "../pages/RegisterEntrepeneur/RegisterEntrepeneur";
import Search from "../pages/Search/Search";
import DescricaoDeProduto from "../pages/DescricaoDeProduto/DescricaoDeProduto";
import SenhaAlterada from "../pages/SenhaAlterada/SenhaAlterada";
import CadastroFinalizado from "../pages/CadastroFinalizado/cadastro";
import EsqueciSenha from "../pages/EsqueciSenha/EsqueciSenha";
import NewPassword from "../pages/NewPassword/NewPassword";
import EmailVerification from "../pages/ValidationEmail/EmailVerification";
import NaoEncontrada from "../pages/NaoEncontrada/NaoEncontrada";

// Páginas protegidas — qualquer usuário logado
import Carrinho from "../pages/Carrinho/Carrinho";
import Pagamento from "../pages/Pagamento/Pagamento";
import CompraFinalizada from "../pages/CompraFinalizada/CompraFinalizada";
import ConfirmOrder from "../pages/ConfirmOrder/ConfirmOrder";
import TrackerOrder from "../pages/TrackerOrder/TrackerOrder";
import VisualizarConversaCliente from "../pages/VisualizarConversa/VisualizarConversa";

// Páginas por role
import ClientAccount from "../pages/ClientAccount";
import EntrepreneurAccount from "../pages/EntrepreneurAccount";
import AdminAccount from "../pages/AdminAccount";
import AdminDashboard from "../pages/AdminDashboard/AdminDashboard";
import AdminTaxas from "../pages/AdminTaxas/AdminTaxas";
import AdminRelatorio from "../pages/AdminRelatorio/AdminRelatorio";
import ListaUsers from "../pages/ListaUsers/ListaUsuarios";
import AdminCupons from "../pages/AdminCupons/AdminCupons";
import CriarLoja from "../components/CriarLoja/CriarLoja";
import { ProtectedRoute } from "./ProtectedRoute";

const AppRouter = () => {
  return (
    <RoutesDom>

      {/* ── Rotas públicas ── */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/options" element={<RegisterOptions />} />
      <Route path="/register/Entrepeneur" element={<RegisterEntrepeneur />} />
      <Route path="/search/:page" element={<Search />} />
      <Route path="/DescricaoDeProduto/:id" element={<DescricaoDeProduto />} />
      <Route path="/nova-senha" element={<NewPassword />} />
      <Route path="/esqueciasenha" element={<EsqueciSenha />} />
      <Route path="/senhaalterada" element={<SenhaAlterada />} />
      <Route path="/cadastrofinalizado" element={<CadastroFinalizado />} />
      <Route path="/EmailVerification" element={<EmailVerification />} />

      {/* ── Rotas protegidas — qualquer usuário logado ── */}
      <Route path="/carrinho" element={
        <ProtectedRoute>
          <Carrinho />
        </ProtectedRoute>
      } />
      <Route path="/pagamento" element={
        <ProtectedRoute>
          <Pagamento />
        </ProtectedRoute>
      } />
      <Route path="/Comprafinalizada" element={
        <ProtectedRoute>
          <CompraFinalizada />
        </ProtectedRoute>
      } />
      <Route path="/ConfirmOrder" element={
        <ProtectedRoute>
          <ConfirmOrder />
        </ProtectedRoute>
      } />
      <Route path="/MinhaConta/VisualizarConversaCliente" element={
        <ProtectedRoute>
          <VisualizarConversaCliente />
        </ProtectedRoute>
      } />

      {/* ── Rotas de Client ── */}
      <Route path="/auth/client/account/:content/:subContent?/:id?" element={
        <ProtectedRoute allowedRoles={["Client"]}>
          <ClientAccount />
        </ProtectedRoute>
      } />
      <Route path="/client/order/:orderId" element={
        <ProtectedRoute allowedRoles={["Client"]}>
          <TrackerOrder />
        </ProtectedRoute>
      } />

      {/* ── Rotas de Entrepreneur ── */}
      <Route path="/auth/entrepreneur/account/:content/:subContent?/:id?" element={
        <ProtectedRoute allowedRoles={["Entrepeneur"]}>
          <EntrepreneurAccount />
        </ProtectedRoute>
      } />
      <Route path="/CriarLoja" element={
        <ProtectedRoute allowedRoles={["Entrepeneur"]}>
          <CriarLoja />
        </ProtectedRoute>
      } />

      {/* ── Rotas de Admin ── */}
      <Route path="/auth/admin/account/:content" element={
        <ProtectedRoute allowedRoles={["Admin"]}>
          <AdminAccount />
        </ProtectedRoute>
      } />
      <Route path="/AdminDashboard" element={
        <ProtectedRoute allowedRoles={["Admin"]}>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/AdminTaxas" element={
        <ProtectedRoute allowedRoles={["Admin"]}>
          <AdminTaxas />
        </ProtectedRoute>
      } />
      <Route path="/AdminRelatorio" element={
        <ProtectedRoute allowedRoles={["Admin"]}>
          <AdminRelatorio />
        </ProtectedRoute>
      } />
      <Route path="/ListaUsuarios" element={
        <ProtectedRoute allowedRoles={["Admin"]}>
          <ListaUsers />
        </ProtectedRoute>
      } />
      <Route path="/AdminCupons" element={
        <ProtectedRoute allowedRoles={["Admin"]}>
          <AdminCupons />
        </ProtectedRoute>
      } />

      {/* ── 404 ── */}
      <Route path="*" element={<NaoEncontrada />} />

    </RoutesDom>
  );
};

export default AppRouter;